module.exports = __webpack_public_path__ + "static/media/pride_pet_door.0287ff48.png";